// extracted by mini-css-extract-plugin
export default {"card":"PlusNewFeatureCard_card__3lzai","title":"PlusNewFeatureCard_title__z0DEU","description":"PlusNewFeatureCard_description__VjGPX"};